import React from 'react';
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import SectionTitle from "../../elements/sectionTitle/SectionTitle";
import TeamThree from "../../elements/team/TeamThree";
import { FiArrowRight, FiMail } from 'react-icons/fi';

const EmergingLeaders = () => {

    const committeeMembers = [
        { image: '#', name: 'Alayna Carlson', designation: 'Committee Member', company: 'Tegrete' },
        { image: '#', name: 'Nico Hanson', designation: 'Committee Member', company: 'Bassford Remele' },
        { image: '#', name: 'Leah Litzau', designation: 'Committee Member', company: 'Falcon National Bank' },
        { image: '#', name: 'Austin Wiberg', designation: 'Committee Member', company: 'North American Banking Company' },
        { image: '#', name: 'Wynter Holien', designation: 'Committee Member', company: 'Premier Banks' },
        { image: '#', name: 'Noah Dendinger', designation: 'Committee Member', company: 'Jacobs Financial' },
    ];

    return (
        <>
            <SEO title="Emerging Leaders | I94 West Chamber" />
            <Layout>
                <div className="main-content emerging-leaders-page">

                    {/* Overview Section */}
                    <div className="container mt--30">
                        <div className="row justify-content-center mt--50 mb--30">
                            <div className="col-12 text-center">
                                <img src={`${process.env.PUBLIC_URL}/images/emerging-leaders/white-logo.webp`} alt="Emerging Leaders Logo" style={{maxWidth: '280px'}} />
                            </div>
                        </div>
                        <div className="row row--30 align-items-stretch mb--50" style={{paddingBottom: '40px', borderBottom: '2px solid #fdb913'}}>
                            <div className="col-lg-5">
                                <div style={{
                                    backgroundImage: `url(${process.env.PUBLIC_URL}/images/emerging-leaders/3-people-smiling.webp)`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    borderRadius: '10px',
                                    height: '100%',
                                    minHeight: '300px'
                                }} />
                            </div>
                            <div className="col-lg-7 mt_md--30 mt_sm--30">
                                <div className="content">
                                    <div className="section-title">
                                        <h2 className="title orange">Emerging Leaders Group</h2>
                                        <p>The Emerging Leaders Group is designed for young professionals and professionals at all stages who are looking to grow, connect, and get more involved in the local business community.</p>
                                        <p>Whether you're early in your career, new to the area, stepping into a new role, or simply looking for more opportunities to engage, this group provides a welcoming space to build relationships, develop skills, and expand your network.</p>
                                        <p>Through a mix of networking events, professional development, and community involvement, Emerging Leaders helps individuals take the next step in their journey.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Who It's For + Events */}
                    <div className="container mb--50">
                        <div className="row row--30">
                            <div className="col-lg-12 mb--30">
                                <img src={`${process.env.PUBLIC_URL}/images/emerging-leaders/new-group-photo.webp`} alt="Emerging Leaders members" style={{width: '100%', maxHeight: '350px', objectFit: 'cover', objectPosition: 'center 80%', borderRadius: '10px'}} />
                            </div>
                            <div className="col-lg-6 mt_md--30 mt_sm--30">
                                <h3 className="title">Who It's For</h3>
                                <p>Emerging Leaders events are designed to be:</p>
                                <ul className="list-numbers">
                                    <li><h4>Approachable</h4><p>Relaxed, welcoming environment</p></li>
                                    <li><h4>Relevant</h4><p>Topics focused on real-world growth and leadership development</p></li>
                                    <li><h4>Flexible</h4><p>Attend what fits your schedule</p></li>
                                    <li><h4>Engaging</h4><p>A mix of social and professional experiences</p></li>
                                </ul>
                            </div>
                            <div className="col-lg-6 mt_md--30 mt_sm--30">
                                <h3 className="title">Events May Include</h3>
                                <ul className="list-style--1">
                                    <li>Networking happy hours</li>
                                    <li>Skill-building workshops</li>
                                    <li>Volunteer opportunities</li>
                                    <li>Social events (trivia nights, themed gatherings, etc.)</li>
                                </ul>

                                <h3 className="title mt--40">Why Get Involved</h3>
                                <p>Members who participate in Emerging Leaders often:</p>
                                <ul className="list-style--1">
                                    <li>Build meaningful professional relationships</li>
                                    <li>Gain confidence in networking settings</li>
                                    <li>Learn from experienced business leaders</li>
                                    <li>Increase visibility within the Chamber and local business community</li>
                                </ul>
                                <p className="mt--20">It's one of the easiest ways to get plugged into the Chamber and start seeing value from your membership right away.</p>
                            </div>
                        </div>
                    </div>

                    {/* Upcoming Events */}
                    <div style={{
                        padding: '60px 0',
                        background: `linear-gradient(rgba(38, 82, 120, 0.85), rgba(38, 82, 120, 0.85)), url(${process.env.PUBLIC_URL}/images/emerging-leaders/4-people-smiling.webp)`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        marginBottom: '50px'
                    }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <SectionTitle
                                        textAlign="text-center"
                                        radiusRounded=""
                                        subtitle="Stay Up To Date"
                                        title="Upcoming Events"
                                        description="Stay up to date with upcoming Emerging Leaders events and opportunities."
                                    />
                                    <div className="text-center mt--30">
                                        <a href="https://business.i94westchamber.org/events" className="btn-default btn-icon">
                                            View Upcoming Events <i className="icon"><FiArrowRight /></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Get Connected */}
                    <div className="container mb--50">
                        <div className="row row--30 align-items-center">
                            <div className="col-lg-6 mt_md--30 mt_sm--30">
                                <h3 className="title orange">Get Connected</h3>
                                <p>Interested in learning more or joining the committee? You can:</p>
                                <ul className="list-style--1">
                                    <li>Attend an upcoming event</li>
                                    <li>Invite a coworker or friend</li>
                                    <li>Reach out to the Chamber office for details on the next committee meeting</li>
                                    <li>Connect with us at the next Chamber event</li>
                                </ul>
                            </div>
                            <div className="col-lg-6 mt_md--30 mt_sm--30">
                                <div className="mini-contact">
                                    <img src={`${process.env.PUBLIC_URL}/images/placeholder_2.jpg`} alt="Abby Ciesynski" />
                                    <div style={{'listStyleType': 'none', 'color': 'black'}}>
                                        <h2 className="title m-center orange">Get In Contact</h2>
                                        <h4>Abby Ciesynski</h4>
                                        <li>
                                            <a href="mailTo:abby@i94westchamber.org">
                                                <FiMail /> abby@i94westchamber.org
                                            </a>
                                        </li>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Emerging Leaders Committee */}
                    <div className="container mt--50 mb--100">
                        <div className="row row--30">
                            <div className="col-lg-12 mb--10">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle="Meet The Team"
                                    title="Emerging Leaders Committee"
                                />
                            </div>
                        </div>
                        <TeamThree teamStyle="team-style-default" teamData={committeeMembers} />
                    </div>

                </div>
            </Layout>
        </>
    )
}
export default EmergingLeaders;
